import { render, staticRenderFns } from "./Skill.vue?vue&type=template&id=6f6f2d9e&scoped=true"
import script from "./Skill.vue?vue&type=script&lang=js"
export * from "./Skill.vue?vue&type=script&lang=js"
import style0 from "./Skill.vue?vue&type=style&index=0&id=6f6f2d9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6f2d9e",
  null
  
)

export default component.exports